import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

const defaultValues = {
  descMotivo: '',
};

const resolver = ({isMotivo}) => yupResolver(
  yup.object().shape({
    descMotivo: isMotivo ? yup.string().required('Se requiere un motivo.'): yup.string(),    
  })
);



export { defaultValues, resolver };
